import React, { useState } from "react"
import { injectIntl } from "react-intl"
import {
    ItemCustomAttributeValue
} from "../../state/product-custom-attributes/CustomAttributeDefinition"
import { CustomAttributeWrapperProps } from "../types"
import CustomAttributeSelect from "./CustomAttributeSelect"
import CustomAttributeValueInput from "./CustomAttributeValueInput"

const CustomAttributeWrapper = (props: CustomAttributeWrapperProps) => {
    const [customAttributeDefValue, setCustomAttributeDefValue] = useState<string | string[]>(props.value)

    //the value is the input text for the text type and it is the ProductCustomDefinitionImageMetadata id when it is a select
    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedCustomAttributes: ItemCustomAttributeValue[] = []
        props.itemCustomAttributesDefinitions.map(definition => {
            const customAttributeValue = props.itemCustomAttributesValues.find(e => e.customAttributeDefinitionId === definition.id)
            const item: ItemCustomAttributeValue = {
                customAttributeDefinitionId: definition.id,
                label: customAttributeValue?.label || "",
                rowId: customAttributeValue?.rowId || "",
            }

            if (definition.attributes.attributeType === "text") {
                item.textValue = customAttributeValue?.textValue || ""
            }

            if (definition.attributes.attributeType === "select") {
                item.selectValue = customAttributeValue?.selectValue || []
            }

            if (customAttributeValue?.customAttributeDefinitionId == props.definitionId) {
                if (!(event instanceof Array)) {
                    item.textValue = event.target.value,
                    setCustomAttributeDefValue(item.textValue)
                }
                if (event instanceof Array) {
                    item.selectValue = event.length > 0 && event.map(v => v !== null ? v.value : "") || []
                    setCustomAttributeDefValue(item.selectValue)
                }
            }
            updatedCustomAttributes.push(item)
            
        })

        props.onChange(updatedCustomAttributes)
    }
    
   
    for (const index in props.itemCustomAttributesDefinitions) {
        if (props.itemCustomAttributesDefinitions[index].id === props.definitionId) {
            switch (props.itemCustomAttributesDefinitions[index].attributes.attributeType) {
            case "select":
                return <CustomAttributeSelect
                    isMulti={props.itemCustomAttributesDefinitions[index]?.attributes.allowMoreThanOneChoice}
                    value={(customAttributeDefValue || []) as string[]}
                    customAttribute={props.itemCustomAttributesDefinitions[index].attributes.customFieldDefinitionLabel}
                    onChangeCallback={(updatedCustomAttributes) => onChangeHandler(updatedCustomAttributes)}
                />
            default:
                return  <>
                    <CustomAttributeValueInput
                        value={customAttributeDefValue as string}
                        onChange={(updatedCustomAttributes) => onChangeHandler(updatedCustomAttributes)}
                    />
                </> 
            }
        }
    }
  
}

export default injectIntl(CustomAttributeWrapper)



// WEBPACK FOOTER //
// ./src/common/form/CustomAttributeWrapper.tsx